"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../shared/styles");
var _useOrientations = require("../shared/hooks/useOrientations");
var _jsxRuntime = require("react/jsx-runtime");
var Menu = _styledComponents.default.div.withConfig({
  displayName: "NestedContextMenu__Menu",
  componentId: "sc-1vfcdoz-0"
})(["position:absolute;box-sizing:border-box;display:flex;flex-direction:column;align-items:flex-start;width:295px;max-height:400px;background-color:", ";padding-top:", ";", " ", " gap:", ";", " border-radius:", ";z-index:1;"], _styles.colors.background.primary, _styles.spacing.xs, function (_ref) {
  var verticalPos = _ref.verticalPos;
  return verticalPos === 'above' ? (0, _styledComponents.css)(["bottom:0;margin-bottom:-", ";"], _styles.spacing.xs) : (0, _styledComponents.css)(["top:0;margin-top:-", ";"], _styles.spacing.xs);
}, function (_ref2) {
  var horizontalPos = _ref2.horizontalPos;
  return horizontalPos === 'right' ? (0, _styledComponents.css)(["left:100%;margin-left:", ";"], _styles.spacing.xxs) : (0, _styledComponents.css)(["right:100%;margin-right:", ";"], _styles.spacing.xxs);
}, _styles.spacing.xs, _styles.shadow.m, _styles.borderRadius.m);
var NestedContextMenu = function NestedContextMenu(_ref3) {
  var children = _ref3.children,
    bounds = _ref3.bounds,
    verticalPos = _ref3.verticalPos,
    horizontalPos = _ref3.horizontalPos;
  var ref = (0, _react.useRef)();
  var orientations = (0, _useOrientations.useOrientations)(ref, bounds, verticalPos, horizontalPos);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Menu, {
    ref: ref,
    verticalPos: orientations.verticalOrientation,
    horizontalPos: orientations.horizontalOrientation,
    children: children
  });
};
NestedContextMenu.defaultProps = {
  verticalPos: 'above',
  horizontalPos: 'left',
  bounds: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};
var _default = exports.default = NestedContextMenu;